import React from 'react';

const OnboardingStep = ({ content, currentStep, totalSteps, onNext, onPrev, goToStep }) => {
    // Генерация индикаторов шагов (точек)
    const renderStepDots = () => {
        const dots = [];
        for (let i = 0; i < totalSteps; i++) {
            dots.push(
                <div
                    key={i}
                    className={`step-dot ${i === currentStep ? 'active' : ''}`}
                    onClick={() => i < currentStep ? goToStep(i) : i > currentStep ? onNext() : null}
                />
            );
        }
        return dots;
    };

    return (
        <div className="onboarding-step-container">
            <div className="step-content">
                <h2 className="step-title">{content.title}</h2>

                <div className="step-description-wrapper">
                    <div className="description-background">
                        <div className="background-rect"></div>
                        <svg className="corner top-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34 2H13.6364L2 12.2655V31" stroke="#009F03" strokeWidth="5" strokeMiterlimit="10" />
                        </svg>
                        <svg className="corner top-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 2H36.3636L48 12.2655V31" stroke="#009F03" strokeWidth="5" strokeMiterlimit="10" />
                        </svg>
                        <svg className="corner bottom-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34 48H13.6364L2 37.7345V19" stroke="#009F03" strokeWidth="5" strokeMiterlimit="10" />
                        </svg>
                        <svg className="corner bottom-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 48H36.3636L48 37.7345V19" stroke="#009F03" strokeWidth="5" strokeMiterlimit="10" />
                        </svg>
                    </div>
                    <p className="step-description">{content.description}</p>
                </div>
            </div>

            <div className="step-navigation">
                <div className="step-dots">
                    {renderStepDots()}
                </div>

                <div className="step-buttons">
                    <button
                        className="step-button prev-button"
                        onClick={onPrev}
                    >
                        Назад
                    </button>
                    <button
                        className="step-button next-button"
                        onClick={onNext}
                    >
                        {currentStep === totalSteps - 1 ? 'Заполнить профиль' : 'Далее'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OnboardingStep; 